export default function SubscriptionSummary({
  plan,
  combinedItems = [],
  onAddToSubscription = [],
}) {
  // Example base prices per plan
  const planPrices = {
    Free: 0,
    Founders: 49,
    Growth: 99,
    Enterprise: 199,
  };

  const basePrice = planPrices[plan] || 0;
  const isFreePlan = plan.toLowerCase() === "free";

  // Calculate price increase
  const totalAddonsPrice = combinedItems.reduce((sum, item) => {
    const numeric = parseFloat(item.price?.replace(/[^0-9.]/g, "")) || 0;
    return sum + numeric;
  }, 0);

  const newTotal = basePrice + totalAddonsPrice;

  return (
    <div className="w-full bg-white rounded-2xl shadow-md p-6 mt-10">
      <h2 className="text-xl font-semibold mb-4">Subscription Summary</h2>

      <div className="flex justify-between items-center border-b pb-3 mb-3">
        <span className="text-gray-600">Current Plan ({plan})</span>
        <span className="font-medium">£{basePrice.toFixed(2)}/mo</span>
      </div>

      {combinedItems.length > 0 ? (
        <>
          <h3 className="font-medium text-gray-800 mb-2">New Additions</h3>
          <ul className="space-y-2 max-h-64 overflow-y-auto pr-2 custom-scrollbar mb-3">
            {combinedItems.map((item, idx) => (
              <li
                key={`${item.name}-${idx}`}
                className="flex justify-between text-sm border-b border-gray-100 pb-1"
              >
                <span>
                  {item.name}{" "}
                  <span className="text-gray-400">
                    ({item.type === "addon" ? "Add-on" : "Connection"})
                  </span>
                </span>
                <span className="font-medium">
                  {item.price ? item.price : "Included"}
                </span>
              </li>
            ))}
          </ul>

          <div className="flex justify-between text-base font-medium border-t pt-2">
            <span>Additional Monthly Cost</span>
            <span>£{totalAddonsPrice.toFixed(2)}</span>
          </div>

          <div className="flex justify-between text-lg font-semibold text-indigo-700 mt-2">
            <span>New Total</span>
            <span>£{newTotal.toFixed(2)}/mo</span>
          </div>

          <button
            className="w-full mt-6 bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition disabled:opacity-50"
            onClick={() => onAddToSubscription(combinedItems)}
            disabled={combinedItems.length === 0}
          >
            Confirm & Add to Subscription
          </button>
        </>
      ) : (
        <p className="text-sm text-gray-500 text-center mt-4">
          No new add-ons or connections selected.
        </p>
      )}

      {isFreePlan && (
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-600 mb-3">
            You’re on a free plan — upgrade to add premium features.
          </p>
          <button
            className="w-full bg-gray-100 text-gray-800 py-2 px-4 rounded-lg hover:bg-gray-200 transition"
            onClick={() => onAddToSubscription("upgrade")}
          >
            Upgrade Plan
          </button>
        </div>
      )}

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #c4c4c4;
          border-radius: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #999;
        }
      `}</style>
    </div>
  );
}
